(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-switching-tab"] && !Shopify.designMode) return;
  try {
    
  let tabs = document.getElementsByClassName('collection-switching-tab__item');
  let tabArray = Array.from(tabs);
  tabArray.forEach(function (target) {
    target.addEventListener('click', function () {
      let tabs = target.parentElement;
      let activeTag = tabs.getElementsByClassName('is-active')[0];
      activeTag.classList.remove('is-active');
      let num = target.getAttribute('index');
      target.setAttribute('class', 'is-active collection-switching-tab__item');
      tabs.setAttribute('id', 'current_tab_' + num);
      // 横スワイプ表示のときは、切り替えた先の一覧を先頭から表示する
      let swipeList = tabs.parentElement.querySelector(
        '#collection-switching-tab__content_' + num + ' .collection-switching-tab__swipe'
      );
      if (swipeList) swipeList.scrollLeft = 0;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-swym-wishlist"] && !Shopify.designMode) return;
  try {
    
  // ProductGrid DOM
  const productCardMarkup = `
  <ul id="product-grid" class="grid grid--2-col">
  {{#products}}
    <li class="grid__item">
      <div class="card-wrapper">
        <div class="card card--standard card--media">
          <div class="card__inner ratio underline-links-hover" style="--ratio-percent: 100%;">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                <img class="motion-reduce" loading="lazy" src="{{ iu}}" width="50" height="50"/>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information underline-links-hover">
              <h3 class="card__heading h5 cart__product-title">
                <a href="{{ du }}" class="full-unstyled-link">{{ dt }}</a>
              </h3>
              <span class="variant">{{ vi }}</span>
              <div class="card-information">
                <div class="price">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="price-item price-item--regular">{{ formattedPr }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            class="button button--full-width button--secondary swym-wishlist__add-button"
            type="button"
            data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"
            data-product-url="{{du}}"
            data-variant-id="{{epi}}"
            data-product-id="{{empi}}"
          >
            <span>カートに追加</span>
          </button>
        </div>
      </div>
      <button
        class="swym-wishlist__remove-button"
        data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"
        data-product-url="{{du}}"
        data-variant-id="{{epi}}"
        data-product-id="{{empi}}"
      >
        <svg role="presentation" viewBox="0 0 16 14">
          <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
        </svg>
      </button>
    </li>
  {{/products}}
  </ul>
  `;

  // Empty Dom
  const empty = `
    <div class="wishlist-products--empty">
      <h3>お気に入りはありません😢<br>アイテムをお気に入りしましょう✨</h3>
    </div>
  `;

  // 商品の取得
  function swymCallbackFn() {
    _swat.fetchWrtEventTypeET(function (products) {
      const wishlistProducts = products.map(function (p) {
        p.formattedPr = Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(Math.round(p.pr));
        p = SwymUtils.formatProductPrice(p);
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
        return p;
      });

      const container = document.getElementById('wishlist-products');

      if (wishlistProducts.length > 0) {
        var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, { products: wishlistProducts });
        container.innerHTML = productCardsMarkup;
      } else {
        container.innerHTML = empty;
      }

      attachClickListeners();
    }, _swat.EventTypes.addToWishlist);
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

  // カート追加ボタンクリック
  function onAddToCartClick(e) {
    e.preventDefault();
    let epi = +e.currentTarget.getAttribute('data-variant-id');
    let empi = +e.currentTarget.getAttribute('data-product-id');
    var du = e.target.getAttribute('data-product-url');
    window._swat.replayAddToCart(
      { empi: empi, du: du },
      epi,
      function () {
        // 商品の削除
        window._swat.fetch(function (products) {
          products.forEach(function (product) {
            if (empi && epi && product.epi == epi && product.empi == empi) {
              window._swat.removeFromWishList(product, () => {});
            }
          });
        });
        // リダイレクト
        window.location.href = '/cart';
      },
      function (e) {
        console.log(e);
      }
    );
    // 商品の削除
  }

  // 削除ボタンクリック
  function onRemoveBtnClick(e) {
    e.preventDefault();
    let epi = +e.currentTarget.getAttribute('data-variant-id');
    let empi = +e.currentTarget.getAttribute('data-product-id');
    window._swat.fetch(function (products) {
      products.forEach(function (product) {
        if (epi && empi && product.epi == epi && product.empi == empi) {
          window._swat.removeFromWishList(product, function () {
            if (!window.SwymCallbacks) {
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);
          });
        }
      });
    });
  }

  // イベントの紐付け
  function attachClickListeners() {
    const addToCartButtons = document.getElementsByClassName('swym-wishlist__add-button');
    const removeButtons = document.getElementsByClassName('swym-wishlist__remove-button');

    for (let i = 0; i < addToCartButtons.length; i++) {
      addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
    }

    for (let i = 0; i < removeButtons.length; i++) {
      removeButtons[i].addEventListener('click', onRemoveBtnClick, false);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
